import React, { useCallback, useMemo } from 'react'
import dayjs from 'dayjs'
import SydSelect from '../../../../commonDesign/SydSelect'
import SydInput from '../../../../commonDesign/SydInput'
import SydLabel from '../../../../commonDesign/SydLabel'
import { useSyncedTransactions } from './SyncedTransactionsProvider'
import { QUICK_DATE_OPTIONS } from './quickDates'

const toolbarStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'flex-end',
  gap: '8px',
  padding: '8px 0'
}

const datePickerCell = {
  minWidth: '130px'
}

const customDateCell = {
  display: 'flex',
  gap: '4px',
  alignItems: 'flex-end'
}

export default function SyncedTransactionsToolbar () {
  const {
    config,
    quickDate,
    customDateRange,
    onQuickDateChange,
    onCustomDateRangeChange
  } = useSyncedTransactions()

  const dateOptions = useMemo(() => {
    const available = config.availableQuickDates
    if (!available) return QUICK_DATE_OPTIONS
    const allowed = new Set(available)
    allowed.add('Custom')
    return QUICK_DATE_OPTIONS.filter(o => allowed.has(o.value))
  }, [config.availableQuickDates])

  const handleDateSelect = useCallback((e) => {
    onQuickDateChange(e.target.value)
  }, [onQuickDateChange])

  const handleStartDate = useCallback((e) => {
    onCustomDateRangeChange({
      startDate: e.target.value,
      endDate: customDateRange?.endDate ?? dayjs().format('YYYY-MM-DD')
    })
  }, [customDateRange, onCustomDateRangeChange])

  const handleEndDate = useCallback((e) => {
    onCustomDateRangeChange({
      startDate: customDateRange?.startDate ?? dayjs().startOf('year').format('YYYY-MM-DD'),
      endDate: e.target.value
    })
  }, [customDateRange, onCustomDateRangeChange])

  return (
    <div style={toolbarStyle}>
      <div style={datePickerCell}>
        <SydLabel label='Date Range'>
          <SydSelect
            options={dateOptions}
            value={quickDate}
            onChange={handleDateSelect}
            size='sm'
          />
        </SydLabel>
      </div>

      {quickDate === 'Custom' ? (
        <div style={customDateCell}>
          <SydLabel label='Start'>
            <SydInput
              type='date'
              value={customDateRange?.startDate ?? ''}
              onChange={handleStartDate}
              size='sm'
            />
          </SydLabel>
          <SydLabel label='End'>
            <SydInput
              type='date'
              value={customDateRange?.endDate ?? ''}
              onChange={handleEndDate}
              size='sm'
            />
          </SydLabel>
        </div>
      ) : null}
    </div>
  )
}
